import React from 'react';
import { useTranslatedContent } from '../../i18n/hooks/useTranslatedContent';
import { COMPANY_LEGAL_INFO } from '../../constants/legal';

const FooterCopyright = () => {
  const { t } = useTranslatedContent('footer');

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm text-gray-400">
      <div>
        <p>
          {t('legal.copyright', {
            year: new Date().getFullYear(),
            company: COMPANY_LEGAL_INFO.name
          })}
        </p>
        <p>{COMPANY_LEGAL_INFO.legalForm}</p>
        <p>Capital social : {COMPANY_LEGAL_INFO.shareCapital}</p>
        <p>{COMPANY_LEGAL_INFO.rcsDetails}</p>
      </div>
      <div className="md:text-right">
        <p>{t('legal.hosting.title')}</p>
        <p>{t('legal.hosting.address')}</p>
      </div>
    </div>
  );
};

export default FooterCopyright;